import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";

export interface PaginatedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface PaginationParams {
  page: number;
  pageSize: number;
  sortField?: string;
  sortDirection?: string;
}

const usePaginatedQuery = <T>(
  baseUrl: string,
  params: PaginationParams,
  options?: QueryOptions<PaginatedResult<T>>
) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      urlParams.append(key, value.toString());
    }
  });

  return useUserOrEmployeeQuery<PaginatedResult<T>>(
    {path: `${baseUrl}?${urlParams.toString()}` },
    options);
};

export default usePaginatedQuery;